export default __webpack_public_path__ + "static/media/icon_arrow_right_green.e1fa2b79.svg";